// extracted by mini-css-extract-plugin
export default {"holder":"PageHeaderSection_holder__AVUoT"};